module.exports = __webpack_public_path__ + "img/44.549b66f2.jpg";